import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { Box, Copyright, Container, Logo, Stack } from 'shell/components';
import { PageContext } from 'pages/ProfileSetUp/PageProvider';
import { useViewport } from 'contexts/viewport';
import InformationSelectors from 'components/organisms/SignUp/InformationSelectors';
import NameInputs from 'components/organisms/SignUp/NameModal';

const Mobile = () => {
    const { device } = useViewport();
    const { loading, currentStep, errors, form, handleChange, handleNext, handleComplete, PAGES } =
        useContext(PageContext);

    return (
        <Container device={device} sx={{ height: '100%', pb: 3 }}>
            <CenterBox>
                <Stack alignItems={'center'}>
                    <Logo device={'desktop'} />
                </Stack>
                {currentStep === PAGES.NAME && (
                    <NameInputs
                        device={device}
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        handleNext={() => handleNext(PAGES.DETAILS)}
                        PAGES={PAGES}
                    />
                )}
                {currentStep === PAGES.DETAILS && (
                    <InformationSelectors
                        form={form}
                        loading={loading}
                        errors={errors}
                        handleChange={handleChange}
                        handleNext={handleNext}
                        handleComplete={handleComplete}
                        PAGES={PAGES}
                    />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: theme.spacing(18),
        width: '100%',
        height: '100%',
    };
});

export default Mobile;
